import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export enum SupportTicketStatus {
  open,
  inProgress,
  andreiCheck,
  done,
  inTesting,
  inCorecting,

}
export enum SupportTicketStatusLabel {
  'Deschis',
  'In lucru',
  'Verificare Andrei',
  'Rezolvat',
  'In testare',
  'In corectii',
}

export function SupportTicketStatusObject(){
  let keys = Object.keys(SupportTicketStatus);
  let object = {};
  for (let i = 0; i < keys.length/2; i++){
    object = {...object, [keys[i]]:SupportTicketStatusLabel[i]}
  }
  return object;
}

export enum SupportTicketType {
  undefined,
  bug,
  feature,
  improvement,
  asistenta
}
export enum SupportTicketTypeLabel {
  'Fără tip',
  'Bug',
  'Feature',
  'Improvement',
  'Asistență'
}

export function SupportTicketTypeObject(){
  let keys = Object.keys(SupportTicketType);
  let object = {};
  for (let i = 0; i < keys.length/2; i++){
    object = {...object, [keys[i]]:SupportTicketTypeLabel[i]}
  }
  return object;
}

export enum SupportTicketUrgency {
  low,
  medium,
  high,
  veryhigh
}

export enum SupportTicketUrgencyLabel {
  'Mică',
  'Medie',
  'Mare',
  'Foarte mare'
}

export function SupportTicketUrgencyObject(){
  let keys = Object.keys(SupportTicketUrgency);
  let object = {};
  for (let i = 0; i < keys.length/2; i++){
    object = {...object, [keys[i]]:SupportTicketUrgencyLabel[i]}
  }
  return object;
}

@Injectable({
  providedIn: 'root'
})
export class SupportTicketsService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public getSupportTickets(startUnix, endUnix) {
    const params = new HttpParams()
      .set('startUnix', startUnix)
      .set('endUnix', endUnix);
    return this.httpClient.get(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/getSupportTickets', {params});
  }

  public createSupportTicket(ticket){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/createSupportTicket',
        { ticket },
        { headers });
  }

  public updateSupportTicket(ticket){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/updateSupportTicket',
        { ticket },
        { headers });
  }

  public deleteSupportTicket(id){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/deleteSupportTicket',
        { id },
        { headers });
  }

  public getSupportTicketLogs(ticketId){
    const params = new  HttpParams()
      .set('ticketId', ticketId);
    return this.httpClient.get(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/getSupportTicketLogs', {params});
  }

  public getAllSupportTicketLogs(userId, startUnix, endUnix){
    const params = new  HttpParams()
      .set('userId', userId)
      .set('startUnix', startUnix)
      .set('endUnix', endUnix);
    return this.httpClient.get(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/getAllSupportTicketLogs', {params});
  }

  public createLog(log){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/createSupportTicketLog',
        { log },
        { headers });
  }

  public stopLog(log){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/stopSupportTicketLog',
        { log },
        { headers });
  }

  public updateLog(log){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/updateSupportTicketLog',
        { log },
        { headers });
  }

  public deleteLog(id){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/deleteSupportTicketLog',
        { id },
        { headers });
  }

  public getSupportTicketIdsWithOpenLogsForUser(userId){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/getSupportTicketIdsWithOpenLogsForUser',
        { userId },
        { headers });
  }

  public stopUserLogsForTicket(ticketId, userId){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'admin-support-tickets/AdminSupportTickets/stopUserLogsForTicket',
        { ticketId, userId },
        { headers });
  }

  public getTicketById(ticketId: any) {
    const params = new  HttpParams()
      .set('ticketId', ticketId);

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketById', {params});
  }

  public sendChatToTicket(data: any, message: string, filename: string = '', fileContent: string | null = null) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'support-tickets/SupportTickets/sendChatToTicket',
      {
        data,
        message,
        filename,
        fileContent,
      },
      { headers });
  }

  public getManuals() {
    return this.httpClient.get(this.SERVER_URL + 'manuals/AdminManuals/getManuals');
  }

  public createManual(formData: FormData) {
    return this.httpClient.post(this.SERVER_URL + 'manuals/AdminManuals/createManual', formData);
  }

  public updateManual(formData: FormData) {
    return this.httpClient.post(this.SERVER_URL + 'manuals/AdminManuals/updateManual', formData);
  }

  public deleteManual(id: number) {
    const fd = new FormData();
    fd.append('id', String(id));
    return this.httpClient.post(this.SERVER_URL + 'manuals/AdminManuals/deleteManual', fd);
  }

  public downloadManual(id: number) {
    return this.httpClient.get(this.SERVER_URL + 'manuals/AdminManuals/downloadManual', {
      params: { id: String(id) }
    });
  }
}
